export default __webpack_public_path__ + "static/media/risk-tab-right.c8cd90e9.svg";